<template>
   <span style="display: inline-block; height: 100%">
      My credits: <strong>{{ creditsAmount }}</strong>
   </span>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState(['user']),
    ...mapGetters(['hasUnlimitedSubscription']),
    creditsAmount () {
      if (!this.user) {
        return 'N/A'
      }
      if (this.hasUnlimitedSubscription) {
        return 'Unlimited'
      }
      return this.user.credits
    }
  }
}
</script>
